import React from 'react';

import './Contact.css';

export default function Contact() {
  return (
    <div>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSe7ybq_kBFLH2jdk7xDJPJqKGqOBXqLCCbigwgo06vETM_YWw/viewform?embedded=true"
        width="640"
        height="775"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
        title="Contact Form"
        className="contact-form"
      >
        Cargando…
      </iframe>
    </div>
  );
}
